var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card-actions",
    { staticClass: "card-bg-2" },
    [
      _vm.editForm
        ? [
            _c(
              "PrimaryBtn",
              {
                attrs: { color: "success", icon: "done" },
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("Button.Save")) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "SecondaryBtn",
              {
                on: {
                  click: function ($event) {
                    return _vm.cancelEdit()
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("Button.Cancel")) + "\n    ")]
            ),
          ]
        : [
            _vm.isTenantAdmin && !_vm.file.IsArchived
              ? [
                  _c(
                    "SecondaryBtn",
                    {
                      attrs: { color: "warning", icon: "edit" },
                      on: {
                        click: function ($event) {
                          return _vm.setEdit(true)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("Button.Edit_Metadata")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider", {
                    staticClass: "mx-2",
                    attrs: { vertical: "" },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "SecondaryBtn",
              {
                attrs: { icon: "save_alt", color: "info" },
                on: {
                  click: function ($event) {
                    return _vm.onDownload()
                  },
                },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("Button.Download")) + "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            (_vm.isSystemAdmin || _vm.isTenantAdmin) &&
            _vm.file.ImportId == null
              ? [
                  _vm.isTenantAdmin
                    ? _c("DeleteFileAction", {
                        on: {
                          reload: function ($event) {
                            return _vm.$emit("reload")
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ submit, loading }) {
                                return [
                                  _c(
                                    "SecondaryBtn",
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        loading: loading,
                                        color: "error",
                                        icon: "mdi-delete",
                                        disabled:
                                          !_vm.allowReingestion ||
                                          _vm.file.ImportId != null ||
                                          _vm.file.IsArchived,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return submit(_vm.formFile.Id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n          Delete File\n        "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          783688652
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-divider", {
                    staticClass: "mx-2",
                    attrs: { vertical: "" },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.isTenantAdmin
              ? _c("IngestRdrFileAction", {
                  on: {
                    reload: function ($event) {
                      return _vm.$emit("reload")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ submit, loading }) {
                          return [
                            _c(
                              "SecondaryBtn",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  loading: loading,
                                  color: "info",
                                  icon: "publish",
                                  disabled:
                                    !_vm.allowReingestion ||
                                    _vm.file.IsArchived,
                                },
                                on: {
                                  click: function ($event) {
                                    return submit(_vm.formFile.Id)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm.reviewIngestionLink
                                        ? "Reingest data"
                                        : "Ingest data"
                                    ) +
                                    "\n      "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3654001880
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isTenantAdmin
              ? _c("AutoDetectFileAction", {
                  attrs: { "no-next": "" },
                  on: {
                    reload: function ($event) {
                      return _vm.$emit("reload")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ submit, loading }) {
                          return [
                            _c(
                              "SecondaryBtn",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  loading: loading,
                                  color: "info",
                                  icon: "preview",
                                  disabled: _vm.file.IsArchived,
                                },
                                on: {
                                  click: function ($event) {
                                    return submit(_vm.formFile.Id)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          Auto-detect file type\n        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1179558010
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.reviewIngestionLink
              ? _c(
                  "SecondaryBtn",
                  {
                    staticClass: "ml-2",
                    attrs: {
                      to: _vm.reviewIngestionLink,
                      color: "info",
                      icon: "rule",
                      disabled:
                        _vm.file.IsArchived || _vm.file.ImportId != null,
                    },
                  },
                  [_vm._v("\n      Review file\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.isSystemAdmin || _vm.isTenantAdmin) &&
            _vm.file.ImportId != null &&
            _vm.file.IsExecute &&
            !_vm.file.IsArchived
              ? [
                  _c("v-divider", {
                    staticClass: "mx-2",
                    attrs: { vertical: "" },
                  }),
                  _vm._v(" "),
                  (_vm.isSystemAdmin || _vm.isTenantAdmin) &&
                  _vm.file.ImportId != null &&
                  _vm.file.IsLatestVersion &&
                  _vm.file.IsExecute
                    ? _c("RollbackImportAction", {
                        staticClass: "ml-2",
                        attrs: { importId: _vm.file.ImportId },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.file.IsExecute && !_vm.file.IsArchived
              ? [
                  _c("v-divider", {
                    staticClass: "mx-2",
                    attrs: { vertical: "" },
                  }),
                  _vm._v(" "),
                  _c("ExecutionFileVersionChip", {
                    attrs: {
                      small: "",
                      fileVersions: _vm.file.RelatedFileVersions,
                      isLatestVersion: _vm.file.IsLatestVersion,
                    },
                    on: {
                      "click:version": function ($event) {
                        return _vm.goToFilterVersion($event)
                      },
                    },
                  }),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }